import httpService from "..";

export type GroupPaymentDirection = "Received" | "Paid Out";

export interface GroupPaymentPayload {
  Reference: string;
  GroupID: number;
  Direction: GroupPaymentDirection;
  Amount: number;
  Date: string;
  Method: string;
  Notes?: string;
}

export const getGroupPaymentsApi = async (groupId?: number | string) => {
  const query = groupId !== undefined && groupId !== null && groupId !== ""
    ? `?groupId=${groupId}`
    : "";
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/group-payment${query}`,
    "get"
  );
};

export const getGroupPaymentApi = async (id: number | string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/group-payment/${id}`,
    "get"
  );
};

export const addGroupPaymentApi = async (data: GroupPaymentPayload) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/group-payment`,
    "post",
    data
  );
};

export const editGroupPaymentApi = async (
  id: number | string,
  data: Partial<GroupPaymentPayload>
) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/group-payment/${id}`,
    "put",
    data
  );
};

export const removeGroupPaymentApi = async (id: number | string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/group-payment/${id}`,
    "delete"
  );
};
